module.exports = __webpack_public_path__ + "assets/work-icon.png?54bdbb6d29765ff110280ebe82dde251";